module.exports = __webpack_public_path__ + "assets/img/home7.f8060fc5.png";